import { S } from '../core/game';
import { saveGame } from '../core/save';
import { saveSettings, settings } from '../core/settings';
import { toast } from '../core/effects';
import { LANGS, getLang, m, setLang } from '../i18n';
import { applyMute, sfx } from '../audio/sfx';
import { stopSpeech } from '../audio/speech';
import { endDay } from '../content/dayCycle';
import { h } from './dom';
import { closePanel, openPanel, refreshPanel } from './panel';
import { openBlocks } from './blocks';
import { openEnglish } from './english';
import { openPuzzle } from './puzzle';
import { openShop } from './inventory';
import { say } from './dialog';
import { openTutorial } from './tutorial';
import { extraMenuItems } from '../content/registry';

export function langSelect(onPick?: () => void): HTMLElement {
  return h(
    'div',
    { class: 'lang-select', role: 'radiogroup' },
    LANGS.map((l) =>
      h(
        'button',
        {
          class: `chip${l.code === getLang() ? ' on' : ''}`,
          role: 'radio',
          'aria-checked': String(l.code === getLang()),
          onclick: () => {
            sfx('click');
            setLang(l.code);
            onPick?.();
          },
        },
        l.label,
      ),
    ),
  );
}

export function openMenu(onNewGame: () => void): void {
  openPanel('menu', () => {
    const t = m().menu;
    const item = (label: string, fn: () => void, cls = '') => h('button', { class: `btn menu-item ${cls}`, onclick: () => (sfx('click'), fn()) }, label);
    return {
      title: `⏸ ${t.title}`,
      body: [
        h('h4', null, `🌐 ${t.language}`),
        langSelect(() => refreshPanel('menu')),
        h(
          'div',
          { class: 'menu-grid' },
          item(t.sound(settings.sound), () => {
            settings.sound = !settings.sound;
            saveSettings();
            applyMute();
            refreshPanel('menu');
          }),
          item(t.voice(settings.voice), () => {
            settings.voice = !settings.voice;
            if (!settings.voice) stopSpeech();
            saveSettings();
            refreshPanel('menu');
          }),
          item(`🧱 ${m().tools.blocks}`, () => (closePanel('menu'), openBlocks())),
          item(`🧩 ${m().tools.puzzle}`, () => (closePanel('menu'), openPuzzle())),
          item(`🎤 ${m().tools.english}`, () => (closePanel('menu'), openEnglish())),
          item(`🛒 ${m().side.shop}`, () => (closePanel('menu'), openShop())),
          item(m().tutorial.menu, () => (closePanel('menu'), openTutorial())),
          ...extraMenuItems().map((x) => item(x.label(), () => (closePanel('menu'), x.run()))),
        ),
        h(
          'div',
          { class: 'menu-grid' },
          item(`💾 ${t.save}`, () => {
            saveGame(S());
            toast(t.saved);
          }),
          item(`🌙 ${t.endDay}`, () =>
            say({
              who: t.title,
              icon: '🌙',
              text: t.endDayConfirm,
              choices: [
                { text: m().common.yes, run: () => (closePanel('menu'), endDay()) },
                { text: m().common.no },
              ],
            }),
          ),
          item(`🔄 ${t.newGame}`, () =>
            say({
              who: t.newGame,
              icon: '⚠️',
              text: m().start.confirmNew,
              choices: [
                { text: m().common.yes, run: () => (closePanel('menu'), onNewGame()) },
                { text: m().common.no },
              ],
            }),
          'danger'),
        ),
      ],
      footer: [h('button', { class: 'btn gold', onclick: () => closePanel('menu') }, `▶ ${t.resume}`)],
    };
  });
}
